<template>
  <div class="paymentStatus">
    <base-title text="クレジットカード情報を管理" type="back" :href="`${chounEnvDomain}/user/mypage`" />
    <app-loading v-if="isLoading" class="loading--card" :isLoading="isLoading" />
    <div v-else>
      <template v-if="isRegistered">
        <div class="paymentStatus__subheading">ご登録済みお支払い情報</div>
        <attention-choun v-if="attentionMsg" class="paymentStatus__attention" :text="attentionMsg"/>
        <CardInfo
          class="paymentStatus__info"
          :card-number="card.number"
          :card-expiration="card.expiration"
        />
      </template>
      <NextButton
        class="paymentStatus__button"
        style="justify-content: space-between;"
        :label="buttonLabel"
        @clicked="registCard"
      />
    </div>
  </div>
</template>


<script>
import { mapState, mapGetters } from 'vuex'
import { convertKanjiYMD } from '@/utils/filters'
import * as type from '@/utvStore/store/mutation-types'
import { PAYEE } from '@/CONSTS/'
import moment from 'moment'
import fetchAccountData from '@/utils/fetchAccountData'
import AttentionChoun from './partials/AttentionChoun'
import NextButton from '../common/NextButton'
import CardInfo from '../partials/CardInfo'
import BaseTitle from './partials/BaseTitle'
import getChounEnvDomain from '@/utils/getChounEnvDomain'

export default {
  name: 'PaymentStatusChoun',
  components:{
    AttentionChoun,
    NextButton,
    CardInfo,
    BaseTitle,
  },
  data() {
    return {
      // 登録済みクレカ情報を取得中かどうかに使用
      isLoading: false,
      isRegistered: false,
      attentionMsg: '',
      // 超運Dの環境変数
      chounEnvDomain: getChounEnvDomain(),
    }
  },
  props: {
    chounUser: {
      type: Object,
      default: ()=>{}
    },
    diaryToken: {
      type: String,
      default: ''
    },
  },
  computed: {
    ...mapState({
      accessToken: state => state.auth.accessToken,
      card: state => state.payment.card,
      userInfo: state => state.account.user,
    }),
    ...mapGetters(['isLoggedIn']),
    buttonLabel(){
      return this.isRegistered ? 'クレジットカード情報を変更する' : 'クレジットカード情報を登録する'
    },
    // 購入履歴一覧のURL
    paymentHistoryUrl() {
      return `${this.chounEnvDomain}/payment/history`
    },
  },
  created() {
    if (this.isLoggedIn) this.getPaymentInfo()
  },
  methods: {
    getPaymentInfo() {
      if (this.isLoggedIn && this.accessToken) {
        this.isLoading = true
        //カード情報取得
        this.$store.dispatch(type.GET_PAYMENT_INFO, { access_token: this.diaryToken, is_choun: 1 })
        .then(()=> {
          this.isRegistered = true
          this.attentionCardExpiration()
          // console.log(this.card)
          })
        .catch((err)=> {
          console.log('card-unregistered!')
        })
        .finally(()=>{
          this.isLoading = false
        })
      }
    },
    registCard(){
      location.href = `/cd/change_payment/${this.diaryToken}`
    },
    attentionCardExpiration(){
      // カード有効期限をチェックし１ヶ月前になったら警告を表示する
      const cardExpiration = `${this.card.expiration.substr(0, 4)}-${this.card.expiration.substr(4, 6)}`
      const diffMonth = moment(cardExpiration).diff(moment(), 'month')
      if(diffMonth < 1) this.attentionMsg = 'まもなくクレジットカード有効期限が切れます。有効期限を更新してください。'
      if(!!this.chounUser.payment_err) this.attentionMsg = `停止している商品があります。<a href="${this.paymentHistoryUrl}" style="color: inherit;">購入履歴一覧</a>へ`
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../sass/commons/commonVariables.scss";
.paymentStatus{
  color: $col_base_black;
  max-width: 580px;
  margin: auto;
  border-bottom: solid 1px $col_temp_gray3;

  &__attention{
    margin: 16px 20px 5px !important;
  }
  &__msg{
    width: 100%;
    height: 35px;
    box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.3);
    background: rgba(255, 255, 255, 0.4);
    font-size: 12px;
    line-height: 35px;
    padding: 0 20px;
  }
  &__title {
    font-size: 12px;
    line-height: 18px;
    background: linear-gradient(81.44deg, rgba(#FF7497, 0.07) 21.4%, rgba(#CB8BFF, 0.07) 76.64%);
    padding: 9px 20px 8px;
  }
  &__amazon {
    font-size: 13px;
    line-height: 19px;
    padding: 15px 20px;
    + .paymentStatus__button {
      border-top: solid 1px $col_temp_gray3;
    }
  }
  &__info{
    border-bottom: solid 1px $col_temp_gray3;
    padding: 15px 30px !important;
  }
  &__button{
    padding: 13px 20px 12px;
  }
  &__subheading {
    background: #FFF7CF;
    font-size: 12px;
    line-height: 1;
    padding: 10px 12px;
  }
}
.loading {
  &--card {
    margin: 20px auto;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/ChounDiary/PaymentStatusChoun.vue